export default String.raw`
.set-amount-popup {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 792px;
    height: 316px;
    padding: 32px !important;
    row-gap: 24px;
    user-select: none;

    &__header {
        display: flex;
        justify-content: space-between;
        width: 100%;

        &-title {
            display: flex;
            column-gap: 16px;
            align-items: center;

            svg {
                min-width: 32px;
                min-height: 32px;
                width: 32px;
                height: 32px;
                fill: $dangerColor;
            }

            &-text {
                p {
                    @include body-1-medium;
                    margin-top: 8px;
                }
            }
        }
    }

    &__content {
        display: flex;
        width: 100%;
        gap: 16px;

        &-left {
            display: flex;
            column-gap: 16px;
            align-items: center;

            &-img {
                min-width: 80px;
                min-height: 80px;
                width: 80px;
                height: 80px;
            }

            &-info {
                display: none;

                &-title {
                    @include body-1-medium;
                }

                &-price {
                    @include h4-headline;

                    span {
                        @include body-2-regular;
                    }
                }
            }
        }

        &-text {
            width: 100%;

            &-title {
                @include body-1-medium;
                margin-bottom: 16px;
            }

            &-numbers {
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 16px;
                flex-wrap: wrap;

                &-amount {
                    display: flex;
                    align-items: center;
                    column-gap: 24px;

                    &-price {
                        @include h4-headline;

                        span {
                            @include body-2-regular;
                        }
                    }

                    &-stepper {
                        display: flex;
                        column-gap: 8px;
                        align-items: center;
                    }
                }

                &-sum {
                    span {
                        @include body-1-semi-bold;
                    }
                }
            }
        }
    }

    &__buttons {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        form {
            height: fit-content;
        }

        .pure-button svg {
            width: 14px;
            height: 14px;
        }

        .primary-action-button svg {
            width: 20px;
            height: 20px;
        }

        .primary-action-button:disabled svg {
            fill: #959595;
        }
    }
}
`